import { render, staticRenderFns } from "./ConsultantsByReferrer.vue?vue&type=template&id=3b70f0da&"
import script from "./ConsultantsByReferrer.vue?vue&type=script&lang=js&"
export * from "./ConsultantsByReferrer.vue?vue&type=script&lang=js&"
import style0 from "./ConsultantsByReferrer.vue?vue&type=style&index=0&id=3b70f0da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports